// Component generated with util/vox-create-component.js
import styled from 'styled-components';

/**
 * Components
 */
export const LegacyWrapper = styled.div``;
